/*
 * @Description: 浏览器本地缓存管理
 * @Author: YuKi
 * @Date: 2023-11-20 09:58:24
 */
import config from '@/config';
import { ICountry } from '@/types/common';

/** 登录凭证，key 是线上已在用的，改了会让已登录用户掉线 */
const TOKEN_KEY = 'token';
/** 界面语言，key 同上，改了会重置用户选过的语言 */
const LANGUAGE_KEY = 'language';
/** 菜单展开 */
const MENU_COLLAPSE_KEY = 'menuCollapse';
/** 国家的存储信息 */
const COUNTRY_INFO = 'countryInfo';
/** 刷新token的令牌 */
const REFRESH_TOKEN = 'refreshToken';
/** 埋点的时候需要 */
const OSC_UUID = 'oscUuid';

/** 获取登录 token */
export const getToken = () => localStorage.getItem(TOKEN_KEY) || '';

/** 设置登录 token */
export const setToken = (token: string) => localStorage.setItem(TOKEN_KEY, token);

/** 清除登录 token */
export const removeToken = () => localStorage.removeItem(TOKEN_KEY);

/** 获取本地缓存的语言 */
export const getLocalLanguage = () => localStorage.getItem(LANGUAGE_KEY);

/** 设置本地缓存的语言 */
export const setLocalLanguage = (language: string) => localStorage.setItem(LANGUAGE_KEY, language);
/**
 * @Author: YuKi
 * @description: 获取菜单展开
 * @return {*}
 */
export const getMenuCollapse = () => {
  const value = localStorage.getItem(MENU_COLLAPSE_KEY);
  return value ? value === 'true' : true;
};

/**
 * @Author: YuKi
 * @description: 设置菜单展开
 * @param {boolean} mode 开关
 * @return {*}
 */
export const setMenuCollapse = (mode: boolean) => localStorage.setItem(MENU_COLLAPSE_KEY, mode.toString());

/**
 * @Author: YuKi
 * @description: 获取国家的存储信息。
 * @return {*}
 */
export const getLocalCountryInfo = (): ICountry => {
  const obj = localStorage.getItem(COUNTRY_INFO);
  return obj ? JSON.parse(obj) : config.defaultCountryInfo;
};

/**
 * @Author: YuKi
 * @description: 设置国家的存储信息
 * @return {*}
 */
export const setLocalCountryInfo = (obj: ICountry | '') => localStorage.setItem(COUNTRY_INFO, JSON.stringify(obj));

/**
 * @Author: YuKi
 * @description: 获取刷新Token
 * @return {*} token
 */
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN) || '';

/**
 * @Author: YuKi
 * @description: 设置刷新Token
 * @param {string} token
 */
export const setRefreshToken = (token: string) => localStorage.setItem(REFRESH_TOKEN, token);

/**
 * @Author: YuKi
 * @description: 设置刷新Token
 * @param {string} token
 */
export const removeRefreshToken = () => localStorage.removeItem(REFRESH_TOKEN);

/**
 * @Author: YuKi
 * @description: 设置埋点的uuid
 * @param {string} token
 */
export const setOscUuid = (uuid: string) => localStorage.setItem(OSC_UUID, uuid);

/**
 * @Author: YuKi
 * @description: 获取埋点的uuid
 * @return {*} token
 */
export const getOscUuid = () => {
  if (localStorage.getItem(OSC_UUID)) {
    return localStorage.getItem(OSC_UUID);
  } else {
    const timestamp = Date.now().toString(); // 13位时间戳
    const randomPart = Array.from(
      { length: 19 },
      () =>
        Math.random() > 0.5
          ? Math.floor(Math.random() * 10) // 数字
          : String.fromCharCode(65 + Math.floor(Math.random() * 26)), // 字母
    ).join('');
    const uuid = timestamp + randomPart;
    setOscUuid(uuid);
    return uuid; // 总长度 13 + 19 = 32
  }
};
